// 初始化地图
export default {
    init() {
        return new Promise((resolve, reject) => {
            const url = "https://api.tianditu.gov.cn/api?v=4.0&tk=1b355a85d1aaec6c10308d55a84f1370";
            var script = document.createElement('script');
            script.setAttribute('src',url);
            document.getElementsByTagName('body')[0].appendChild(script)
            var timer = setInterval(function(){
                if (window.T) {
                    clearInterval(timer)
                    resolve(window.T);
                    reject('error');
                }
            },500);
        })
    }
}
